





























import ripple from "./ripple.vue";
import loadingBar from "./loadingBar.vue";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
    components: {
        ripple,
        loadingBar,
    }
})
export default class ImageUpload extends Vue {
    @Prop({}) label:string;
    @Prop({}) awaitUpload:boolean;
    @Prop({}) readonly:boolean;
    @Prop({}) imageLoading:number;
    @Prop({}) defaultImage:string[];

    openFile(){
        this.addPhoto();
    }

    resetPhotos() {
        this.curImagesFiles.splice(0,this.curImagesFiles.length);
        for(let entry of this.defaultImage) {
            this.curImagesFiles.push(entry);
        }
    }

    curImagesFiles:string[] = [];
    imagesLoading:number[] = null;
    addPhoto(){
        if(this.curImagesFiles.length == 0) {
            this.resetPhotos();
        }
        let fileSelector = this.$refs.fileInput as HTMLInputElement;
        fileSelector.click();
        fileSelector.onchange = (ev) => {
            let files = fileSelector.files;
            if(files) {
                for(let file of files){
                    let fileReader = new FileReader();
                    fileReader.readAsBinaryString(file);
                    fileReader.onload = async (e) => {
                        this.createImage(fileReader.result.toString());
                    }
                }
            }
        }
    }

    nocacheImage(url: string) {
        if(url.startsWith("http")) {
            return url + "?timestamp=" + Date.now() + "&nocache=true";
        }
        else {
            return url;
        }
    }

    createImage(string){
        this.displayImage(string)
        this.emitImageChange();
    }

    emitImageChange(){
        this.$emit("imageChange", this.curImagesFiles);
    }

    displayImage(string:string){
        if(string){
            if(string.substring(0,4) == "http") {
                this.curImagesFiles.push(string);
            }
            else {
                let fileDir = 'data:image/jpeg;base64,' + btoa(string);
                this.curImagesFiles.push(fileDir);
            }
        }
    }

    removeAllImages(){
        this.curImagesFiles = [];
    }

    removeImage(index:number){
        this.curImagesFiles = this.defaultImage;
        this.curImagesFiles.splice(index,1);
        this.emitImageChange();
    }

}

